// extracted by mini-css-extract-plugin
module.exports = {"No_Data_Found":"noDataFound_No_Data_Found__2j-jL","No_Data_Found_Label":"noDataFound_No_Data_Found_Label__399ND"};